/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

if (n === 1)
    return 1;
return 5;
}

export default ["syr-SY",[["܏ܩ‌","܏ܒ‌"],["܏ܩܛ‌","܏ܒܛ‌"]],[["܏ܩܛ‌","܏ܒܛ‌"]],[["ܚ","ܬ","ܬ","ܐ","ܚ","ܥ","ܫ"],["ܚܕ","ܬܪܝܢ","ܬܠܬ","ܐܪܒܥ","ܚܡܫ","ܥܪܘ","ܫܒܬܐ"],["ܚܕܒܫܒܐ","ܬܪܝܢܒܫܒܐ","ܬܠܬܒܫܒܐ","ܐܪܒܥܒܫܒܐ","ܚܡܫܒܫܒܐ","ܥܪܘܒܬܐ","ܫܒܬܐ"],["ܚܕ","ܬܪܝܢ","ܬܠܬ","ܐܪܒܥ","ܚܡܫ","ܥܪܘ","ܫܒܬܐ"]],u,[["ܟ","ܫ","ܐ","ܢ","ܐ","ܚ","ܬ","ܐ","ܐ","ܬ","ܬ","ܟ"],["ܟܢܘܢ ܒ","ܫܒܛ","ܐܕܪ","ܢܝܣܢ","ܐܝܪ","ܚܙܝܪܢ","ܬܡܘܙ","ܐܒ","ܐܝܠܘܠ","ܬܫܪܝܢ ܐ","ܬܫܪܝܢ ܒ","ܟܢܘܢ ܐ"],["ܟܢܘܢ ܐܚܪܝܐ","ܫܒܛ","ܐܕܪ","ܢܝܣܢ","ܐܝܪ","ܚܙܝܪܢ","ܬܡܘܙ","ܐܒ","ܐܝܠܘܠ","ܬܫܪܝܢ ܩܕܡܝܐ","ܬܫܪܝܢ ܐܚܪܝܐ","ܟܢܘܢ ܩܕܡܝܐ"]],[["ܟ","ܫ","ܐ","ܢ","ܐ","ܬ","ܚ","ܐ","ܐ","ܬ","ܬ","ܟ"],["ܟܢܘܢ ܒ","ܫܒܛ","ܐܕܪ","ܢܝܣܢ","ܐܝܪ","ܚܙܝܪܢ","ܬܡܘܙ","ܐܒ","ܐܝܠܘܠ","ܬܫܪܝܢ ܐ","ܬܫܪܝܢ ܒ","ܟܢܘܢ ܐ"],["ܟܢܘܢ ܐܚܪܝܐ","ܫܒܛ","ܐܕܪ","ܢܝܣܢ","ܐܝܪ","ܚܙܝܪܢ","ܬܡܘܙ","ܐܒ","ܐܝܠܘܠ","ܬܫܪܝܢ ܩܕܡܝܐ","ܬܫܪܝܢ ܐܚܪܝܐ","ܟܢܘܢ ܩܕܡܝܐ"]],[["܏ܩܡ‌","܏ܫܡ‌"],u,["ܩܕܡ ܡܫܝܚܐ","ܫܢܬܐ ܡܪܢܝܬܐ"]],6,[5,6],["d-MM-y","d ܒMMM y","d ܒMMMM y","EEEE، d ܒMMMM y"],["h:mm a","h:mm:ss a","h:mm:ss a z","h:mm:ss a zzzz"],["{1}، {0}",u,u,u],[".",",",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##0.###","#,##0%","¤ #,##0.00","#E0"],"SYP",u,u,{"JPY":["JP¥","¥"],"USD":["US$","$"]},"rtl", plural];
